export const ACCEPTED_IMAGE_FORMATS = ".jpg,.jpeg,.png,.webp,.svg";
export const ACCEPTED_DOCUMENT_FORMATS = ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt";
export const ACCEPTED_BOTH_FORMATS = `${ACCEPTED_IMAGE_FORMATS},${ACCEPTED_DOCUMENT_FORMATS}`;

export type FileUploadType = 'image' | 'document' | 'both';

export const getAcceptedFormats = (type?: FileUploadType, customAccept?: string) => {
  if (customAccept) return customAccept;
  
  switch (type) {
    case 'image':
      return ACCEPTED_IMAGE_FORMATS;
    case 'document':
      return ACCEPTED_DOCUMENT_FORMATS;
    case 'both':
      return ACCEPTED_BOTH_FORMATS;
    default:
      // Default to both if no type is specified
      return ACCEPTED_BOTH_FORMATS;
  }
};

export const getFormatMessage = (type?: FileUploadType) => {
  switch (type) {
    case 'image':
      return `Allowed formats: JPG, JPEG, PNG, WEBP, SVG`;
    case 'document':
      return `Allowed formats: PDF, DOC, DOCX, XLS, XLSX, CSV, TXT`;
    case 'both':
      return `Allowed formats: Images (JPG, PNG, etc.) & Documents (PDF, DOC, etc.)`;
    default:
      return `Allowed formats: Images & Documents`;
  }
};
